export var name = "@atlaskit/editor-core";
export var version = "205.8.2";